import React, { useState, Suspense, useEffect, SuspenseList } from 'react'
import * as THREE from "three"
import useStore from '../../StateStore/store'

//Hall Assets
import LeftWall from "../Walls/LeftWall"
import RightWalln from "../Walls/RightWalln"
import FrontWall from '../Walls/FrontWall'
import Ground from '../Floor/Ground'
import SideBoundary from '../Walls/SideBoundary'
import WalkableArea from '../Floor/WalkableArea'
import Carpet from "../Carpet/Carpet"
import Sign from "../Sign/Sign"
import Door from "../Door/Door"
import Ceiling from "../Ceiling/Untitled"
import TeleportMarker from '../Marker/TeleportMarker'
// import Dummy from '../../Player/Dummy'
// import FPSNew from '../../Player/FPSNew'
import Blind from '../../Player/Blind'
import  Box  from '../../Player/Box'
// import Firstpersonprespective from '../../Player/Firstpersonprespective'

//Stalls
const Type1Center = React.lazy(() => import('./Stall/Type1_Center'))
const Type1Corner = React.lazy(() => import('./Stall/Type1_corner'))
const Type2Center = React.lazy(() => import('./Stall/Type2_Center'))
const Type2Corner = React.lazy(() => import('./Stall/Type2_corner'))
const Type3Corner = React.lazy(() => import('./Stall/Type3_corner'))
const Type3Center = React.lazy(() => import('./Stall/Type3_center'))

//physics
const Collision = React.lazy(() => import('./Collision/Collision'))
const Collider = React.lazy(() => import('./Collider'))
const TotamPhysics = React.lazy(() => import('../Brandings/TotamPhysics'))

//stall assets
const ReceptionTable = React.lazy(() => import("./ReceptionTable/ReceptionDraco"))
const Reception2 = React.lazy(() => import("./ReceptionTable/Reception2"))
const Broucher = React.lazy(() => import("./Broucher/Broucher"))
const VCTable = React.lazy(() => import("./VCTable/VCTable"))
const KTv = React.lazy(() => import("./KTv/KTv"))
const Display = React.lazy(() => import("./Display/Display"))
const Banners = React.lazy(() => import('./Logo/Banners'))
const Standee = React.lazy(() => import("./Standee/Standee"))
const StallsLight = React.lazy(() => import('./StallsLight/StallsLight'))
const Hotspot = React.lazy(() => import('../../Hotspot/Hotspot'))
const VCStand = React.lazy(() => import("./VCStand/VCStand"))
const Totam = React.lazy(() => import("../Brandings/Totam"))
const SponsorBanner = React.lazy(() => import('../Brandings/SponsorBanner'))
const HangingFlexes = React.lazy(() => import('../Brandings/HangingFlexes'))

// const OtherComponent = React.lazy(() => import('./OtherComponent'));

const zDist = 80

const stallSizes = {
    "type1-center": 45,
    "type1-corner": 45,
    "type1-corner2": 45,
    "type2-center": 55,
    "type2-corner": 55,
    "type2-corner2": 55,
    "type3-center": 70,
    "type3-corner": 70,
    "type3-corner2": 70,
    "null": 0
}

const side = [1, -1]

const add = (arr) => {
    return arr.reduce((a, b) => a + b, 0);
};


const StallPlacement = ({ stallData, types, hotspotData, sponsorsData }) => {

    const [positionData, setPositionData] = useState(undefined)
    const [floorSize, setFloorSize] = useState(0)
    const [mount, setMount] = useState(true)

    const stallPositionState = useStore(state => state.stallPosition)

    React.useLayoutEffect(() => {
        let j = 0

        const pos1 = []
        const pos2 = []
        const pos3 = []
        const pos4 = []
        const pos5 = []
        const pos6 = []

        const color1 = []
        const color2 = []
        const color3 = []
        const color4 = []
        const color5 = []
        const color6 = []

        const logo1 = []
        const logo2 = []
        const logo3 = []
        const logo4 = []
        const logo5 = []
        const logo6 = []

        const banner1 = []
        const banner2 = []
        const banner3 = []
        const banner4 = []
        const banner5 = []
        const banner6 = []

        const video1 = []
        const video2 = []
        const video3 = []
        const video4 = []
        const video5 = []
        const video6 = []

        const stallIndex1 = []
        const stallIndex2 = []
        const stallIndex3 = []
        const stallIndex4 = []
        const stallIndex5 = []
        const stallIndex6 = []

        const stallType = []
        const stallColor = []
        const stallLogo = []
        const stallBanners = []
        const stallVideo = []

        stallData.map((stall, index) => {
            stallType.push(stall.stall_type)
            if (index === stallData.length - 1) {
                stallColor.push([stall.primary_3dcolor, "null"])
                stallLogo.push([stall.logo_url, "null"])
                stallBanners.push([stall.banner_images, "null"])
                stallVideo.push(stall.video_points, "null")

            } else if (index % 2 === 0) {
                stallColor.push([stall.primary_3dcolor, stallData[index + 1].primary_3dcolor])
                stallLogo.push([stall.logo_url, stallData[index + 1].logo_url])
                stallBanners.push([stall.banner_images, stallData[index + 1].banner_images])
                stallVideo.push([stall.video_points, stallData[index + 1].video_points])
            }
        })


        const dummy = new THREE.Object3D()

        let total = 0

        types.forEach((type) => {
            const max = Math.max(stallSizes[type[0]], stallSizes[type[1]])
            total += max
        })

        setFloorSize(total)

        let grid = []
        types.map((type, index) => {
            const max = Math.max(stallSizes[type[0]], stallSizes[type[1]])
            grid.push(max)

            type.map((stall, i) => {
                if (stall === "type1-center") {
                    const t = [...grid]
                    const center = (add(t.splice(0, index))) + grid[index] / 2 - total / 2
                    dummy.position.set(center, 5, zDist * side[i])
                    pos1.push([dummy.position.x, dummy.position.y, dummy.position.z])
                    color1.push(stallColor[index][i])
                    logo1.push((stallLogo[index][i]))
                    banner1.push(stallBanners[index][i])
                    video1.push(stallVideo[index][i])
                    stallIndex1.push(j)
                    j += 1
                } else if (stall === "type1-corner" || stall === "type1-corner2") {
                    const t = [...grid]
                    const center = (add(t.splice(0, index))) + grid[index] / 2 - total / 2
                    dummy.position.set(center, 5, zDist * side[i])
                    pos2.push([dummy.position.x, dummy.position.y, dummy.position.z])
                    color2.push(stallColor[index][i])
                    logo2.push((stallLogo[index][i]))
                    banner2.push(stallBanners[index][i])
                    video2.push(stallVideo[index][i])
                    stallIndex2.push(j)
                    j += 1
                } else if (stall === "type2-center") {
                    const t = [...grid]
                    const center = (add(t.splice(0, index))) + grid[index] / 2 - total / 2
                    dummy.position.set(center, 5, zDist * side[i])
                    pos3.push([dummy.position.x, dummy.position.y, dummy.position.z])
                    color3.push(stallColor[index][i])
                    logo3.push((stallLogo[index][i]))
                    banner3.push(stallBanners[index][i])
                    video3.push(stallVideo[index][i])
                    stallIndex3.push(j)
                    j += 1
                } else if (stall === "type2-corner" || stall === "type2-corner2") {
                    const t = [...grid]
                    const center = (add(t.splice(0, index))) + grid[index] / 2 - total / 2
                    dummy.position.set(center, 5, zDist * side[i])
                    pos4.push([dummy.position.x, dummy.position.y, dummy.position.z])
                    color4.push(stallColor[index][i])
                    logo4.push((stallLogo[index][i]))
                    banner4.push(stallBanners[index][i])
                    video4.push(stallVideo[index][i])
                    stallIndex4.push(j)
                    j += 1
                } else if (stall === "type3-center") {
                    const t = [...grid]
                    const center = (add(t.splice(0, index))) + grid[index] / 2 - total / 2
                    dummy.position.set(center, 5, zDist * side[i])
                    pos5.push([dummy.position.x, dummy.position.y, dummy.position.z])
                    color5.push(stallColor[index][i])
                    logo5.push((stallLogo[index][i]))
                    banner5.push(stallBanners[index][i])
                    video5.push(stallVideo[index][i])
                    stallIndex5.push(j)
                    j += 1
                } else if (stall === "type3-corner" || stall === "type3-corner2") {
                    const t = [...grid]
                    const center = (add(t.splice(0, index))) + grid[index] / 2 - total / 2
                    dummy.position.set(center, 5, zDist * side[i])
                    pos6.push([dummy.position.x, dummy.position.y, dummy.position.z])
                    color6.push(stallColor[index][i])
                    logo6.push((stallLogo[index][i]))
                    banner6.push(stallBanners[index][i])
                    video6.push(stallVideo[index][i])
                    stallIndex6.push(j)
                    j += 1
                }
            })
        })
        setPositionData({
            "type1-center": { pos: pos1, color: color1, index: stallIndex1, logo: logo1, banner: banner1, video: video1 },
            "type1-corner": { pos: pos2, color: color2, index: stallIndex2, logo: logo2, banner: banner2, video: video2 },
            "type2-center": { pos: pos3, color: color3, index: stallIndex3, logo: logo3, banner: banner3, video: video3 },
            "type2-corner": { pos: pos4, color: color4, index: stallIndex4, logo: logo4, banner: banner4, video: video4 },
            "type3-center": { pos: pos5, color: color5, index: stallIndex5, logo: logo5, banner: banner5, video: video5 },
            "type3-corner": { pos: pos6, color: color6, index: stallIndex6, logo: logo6, banner: banner6, video: video6 },
        })



    }, [stallData])

    useEffect(() => {
        if (mount === false) {
            setMount(true)
        }
    }, [mount])

    useEffect(() => {
        setTimeout(() => {
            setMount(false)
        }, 5000)
    }, [positionData])

    React.useEffect(() => {
        stallPositionState.setData(positionData)
    }, [positionData])

    return (
        <>
            {positionData ? (
                <>
                    <Ground size={floorSize} />
                    <WalkableArea size={floorSize} />
                    <Ceiling size={floorSize} />
                    <LeftWall size={floorSize} position={[0, 0, -125]} />
                    <FrontWall size={floorSize} />
                    <RightWalln size={floorSize} position={[0, 0, 123]} />
                    {/* <Carpet size={floorSize} /> */}
                    <SideBoundary size={floorSize} />
                    {/* <Door size={floorSize} /> */}
                    {/* <Sign size={floorSize} /> */}
                    <TeleportMarker/>
                    <Blind position={[0, 0, 0]} />
                    {/* <Box/> */}
                    {/* <Box/>
                    <Box/>
                    <Box/> */}

                    <React.SuspenseList revealOrder="forwards">
                        <Suspense fallback={null} >
                            {/* <Firstpersonprespective/> */}
                        </Suspense>
                        <Suspense fallback={null} >
                            {/* <Collision data={positionData} instanceSize={stallData.length} /> */}
                        </Suspense>
                        <Suspense fallback={null} >
                            {/* <TotamPhysics size={floorSize} /> */}
                        </Suspense>
                        <Suspense fallback={null}>
                            <Type1Center positionData={positionData["type1-center"].pos} color={positionData["type1-center"].color} />
                        </Suspense>
                        <Suspense fallback={null}>
                            <Type1Corner positionData={positionData["type1-corner"].pos} color={positionData["type1-corner"].color} />
                        </Suspense>
                        <Suspense fallback={null}>
                            <Type2Center positionData={positionData["type2-center"].pos} color={positionData["type2-center"].color} />
                        </Suspense>
                        <Suspense fallback={null}>
                            <Type2Corner positionData={positionData["type2-corner"].pos} color={positionData["type2-corner"].color} />
                        </Suspense>
                        <Suspense fallback={null}>
                            <Type3Center positionData={positionData["type3-center"].pos} color={positionData["type3-center"].color} />
                        </Suspense>
                        <Suspense fallback={null}>
                            <Type3Corner positionData={positionData["type3-corner"].pos} color={positionData["type3-corner"].color} />
                        </Suspense>
                        {/* <Suspense fallback={null}>
                            <Broucher data={positionData} instanceSize={stallData.length} />
                        </Suspense>
                        <Suspense fallback={null}>
                            <Display data={positionData} />
                        </Suspense>
                        <Suspense fallback={null}>
                            <VCTable data={positionData} />
                        </Suspense>
                        <Suspense fallback={null}>
                            <StallsLight data={positionData} />
                        </Suspense>
                        <Suspense fallback={null}>
                            <Reception2 data={positionData} instanceSize={stallData.length} />
                        </Suspense>
                        <Suspense fallback={null}>
                            <Banners data={positionData} />
                        </Suspense>
                        <Suspense fallback={null}>
                            <Hotspot data={positionData} hotspotData={hotspotData} />
                        </Suspense>
                        <Suspense fallback={null}>
                            <VCStand data={positionData} />
                        </Suspense>
                        <Suspense fallback={null}>
                            <KTv data={positionData} />
                        </Suspense>
                        <Suspense fallback={null}>
                            <Standee data={positionData} />
                        </Suspense>
                        <Suspense fallback={null} >
                            <ReceptionTable data={positionData} instanceSize={stallData.length} />
                        </Suspense>
                        <Suspense fallback={null}>
                            <Totam size={floorSize} sponsorsData={sponsorsData} />
                        </Suspense>
                        <Suspense fallback={null}>
                            <SponsorBanner size={floorSize} sponsorsData={sponsorsData} />
                        </Suspense>
                        <Suspense fallback={null}>
                            <HangingFlexes stallData={positionData} sponsorsData={sponsorsData} />
                        </Suspense>
                        <Suspense fallback={null}>
                            <Collider data={positionData} />
                        </Suspense> */}
                        <Suspense fallback={null}>
                            {/* <Dummy/> */}
                        </Suspense>
                    </React.SuspenseList>
                </>
            ) : console.log("loading...")}
        </>
    )
}

export default StallPlacement

